import { getSessionPermissions } from "permissions/_stores/permissions-redux-slice";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import ProfileTypePage from "marketplace/_views/profiles/profile-type-page";
import { ProfileTableData } from "marketplace/_views/profiles/profile-table-data";
import { PageTab } from "marketplace/_views/profiles/profiles-page-tabs";
import { useIndividualProfileStore } from "marketplace/_views/profiles/use-marketplace-profile-store";

export default function IndividualProfilesPage() {
  const sessionPermissions = useSelector(getSessionPermissions);
  const profileStore = useIndividualProfileStore();
  const individualProfiles = profileStore.individualProfiles;

  const getShouldDisableRowEditing = useCallback((_profile: ProfileTableData) => false, []);

  return (
    <ProfileTypePage
      activeTab={PageTab.Individual}
      addProfileDisabled={
        !sessionPermissions?.includesReadAccessToMarketplace ||
        (individualProfiles !== undefined && individualProfiles.length > 0)
      }
      addProfileDisabledMessage={getAddProfileDisabledMessage(individualProfiles)}
      getShouldDisableRowEditing={getShouldDisableRowEditing}
      profileStore={profileStore}
    />
  );
}

function getAddProfileDisabledMessage(individualProfiles?: unknown[]): string {
  if (individualProfiles !== undefined && individualProfiles.length > 0) {
    return "You can only have one individual profile";
  }
  return "";
}
